<template>
  <div class="afdc-fuel-filters-box">
    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-ev-levels">{{ $t('Charger types') }}</label>
      <div class="afdc-col-sm-8">
        <select-multiple-dropdown v-model="queryEvLevels" v-bind:options="levelOptions" id="afdc-analyze-ev-levels"/>
      </div>
    </div>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-ev-connectors">{{ $t('Connectors') }}</label>
      <div class="afdc-col-sm-8">
        <select-multiple-dropdown v-model="queryEvConnectors" v-bind:options="connectorOptions" id="afdc-analyze-ev-connectors"/>
      </div>
    </div>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-ev-networks">{{ $t('Networks') }}</label>
      <div class="afdc-col-sm-8">
        <select-multiple-dropdown v-model="queryEvNetworks" v-bind:options="stationEvNetworks(networkOptions)" id="afdc-analyze-ev-networks"/>
      </div>
    </div>
  </div>
</template>

<script>
import SelectMultipleDropdown from '@/components/SelectMultipleDropdown.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  components: {
    SelectMultipleDropdown,
  },

  computed: {
    levelOptions() {
      return this.$store.getters.loaderElecLevels;
    },

    connectorOptions() {
      const connectors = this.$store.getters.loaderElecConnectors;
      const options = [];
      connectors.forEach((connector) => {
        // exclude Level 1 connectors
        if (!connector.level || connector.level.key !== '1') {
          options.push({
            key: connector.key,
            name: connector.name,
          });
        }
      });
      return options;
    },

    networkOptions() {
      return this.$store.getters.loaderElecNetworks;
    },

    queryEvLevels: syncInputRouteQuery('ev_levels'),
    queryEvConnectors: syncInputRouteQuery('ev_connectors'),
    queryEvNetworks: syncInputRouteQuery('ev_networks'),
  },
};
</script>

<style lang="scss">
</style>
